import { defineComponent, inject, computed, provide, h, Fragment } from 'vue';

var CThemeProvider = defineComponent({
  name: "CThemeProvider",
  props: {
    value: {
      type: [Object],
      "default": function _default() {
        return undefined;
      }
    }
  },
  setup: function setup(props, _ref) {
    var slots = _ref.slots;
    var pluginTheme = inject("$chakraTheme");
    var applicationTheme = computed(function () {
      return props.value || pluginTheme;
    });
    provide("$chakraTheme", applicationTheme.value);
    return function () {
      return h(Fragment, slots["default"] == null ? void 0 : slots["default"]({
        $chakraTheme: props.value
      }));
    };
  }
});

export { CThemeProvider as default };
